import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.ApproveAllFiles.title',
    defaultMessage: 'Approve released files on behalf of customer',
  },
  cancel: {
    id: 'containers.OrderPage.components.TaskPage.components.ApproveAllFiles.cancel',
    defaultMessage: 'Cancel',
  },
  loading: {
    id: 'containers.OrderPage.components.TaskPage.components.ApproveAllFiles.loading',
    defaultMessage: 'Approving..',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskPage.components.ApproveAllFiles.submit',
    defaultMessage: 'Approve',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskPage.components.ApproveAllFiles.sideEffects',
    defaultMessage: `
      <li>Approval will show as done by customer</li>
      <li>It will possible trigger an e-mail to you depending on your settings</li>
    `
  },
})
